function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIconM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/filled/suggested/close-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h4li0a1ana"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/suggested/close-circle (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/suggested/close-circle (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/suggested/close-circle",
    style: {
      clipPath: "url(#h4li0a1ana)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/suggested/close-circle (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/suggested/close-circle (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 19.25a9.625 9.625 0 1 1 9.625-9.625 9.636 9.636 0 0 1-9.625 9.625zm0-8.521 2.134 2.545 1.418.007a.172.172 0 0 0 .172-.172.179.179 0 0 0-.039-.109l-2.793-3.33 2.79-3.33a.18.18 0 0 0 .041-.112.17.17 0 0 0-.172-.172l-1.417.007-2.134 2.543L7.492 6.06l-1.421-.005a.172.172 0 0 0-.172.172.179.179 0 0 0 .041.111l2.8 3.328L5.941 13a.175.175 0 0 0-.041.111.172.172 0 0 0 .172.172l1.421-.006 2.132-2.547z",
    transform: "translate(1.375 1.375)",
    style: {
      fill: "#ff7467"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconM);
export default __webpack_public_path__ + "static/media/cancelIcon_m.2037b7d8bef85829291b9e0a2f428f5e.svg";
export { ForwardRef as ReactComponent };